<template>
    <div class="left-block">
        <div class="consultation">
            <img src="../assets/consultation.svg" alt="consultation" class="img-consultation">
            <div class="consultation-text">
                <p class="citation">Prendre soin des autres est le fondement<br> d'une vie heureuse</p>
                <p>Dalai Lama</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.left-block {
    flex: 1;
}
.logo-div {
    display: flex;
    justify-content: flex-start;
}
.consultation-text {
    margin: auto;
    width: 60%;
}
.citation {
    color: #000;
}
@media screen and (max-width:767px){
    .img-consultation {
        width: 100%;
    }
}

</style>
